import getOrganizationVideoPermissionsForUser from './getOrganizationVideoPermissionsForUser';

export default ({ currentUser, organizationId, organizationPermissions, organizations }) => {
  const organizationVideoPermission = getOrganizationVideoPermissionsForUser({
    currentUser,
    organizationPermissions,
    organizations,
  })?.find((org) => org.id === organizationId);
  return organizationVideoPermission?.video_home_editor;
};
